import { Result, backendApi } from "./backendApi";

export interface SyncOrchestrationInstance {
  instanceId: string;
  currentStatus: string;
  createdAt: Date;
  lastUpdatedAt: Date;
}

export interface GetSyncInstancesResponse {
  history: SyncOrchestrationInstance[];
  latestSuccesfull: SyncOrchestrationInstance;
  currentlyRunning: SyncOrchestrationInstance;
}

class GetSyncInstancesRequest {}
class TerminateSyncInstancesRequest {}
class StartEnvironmentSyncRequest {
  syncAllFolders?: boolean;
}

export const environmentSyncApi = {
  async getSyncInstances(): Promise<
    Result<GetSyncInstancesResponse | undefined>
  > {
    let response =
      await backendApi.sendAndGetResponseAsync<GetSyncInstancesResponse>(
        "GetSyncInstances",
        new GetSyncInstancesRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value };
    }

    return response;
  },
  async terminateAllSyncInstances(): Promise<Result<any>> {
    let response = await backendApi.sendAsync(
      "TerminateSyncInstances",
      {} as TerminateSyncInstancesRequest,
    );

    if (response.ok) {
      return { ok: true, value: true };
    }
    return response;
  },
  async startEnvironmentSync(syncAllFolders: boolean): Promise<Result<any>> {
    let response = await backendApi.sendAsync("StartEnvironmentSync", {
      syncAllFolders: syncAllFolders,
    } as StartEnvironmentSyncRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }
    return response;
  },
};
